import _ from 'underscore';
import {
  IParsedProperty,
  IODataErrorItem,
  IErrorObject,
  ODataRawError,
  ICCRawError,
  GetMessageForErrorCodeArgs,
} from './types';

export const errorPropertyReg: RegExp = /((.+)\[(\d+)\]){0,1}(\.)?(.+)?/;

export const getParsedIndexAndProperty = (errorProperty?: string | null): IParsedProperty => {
  if (!errorProperty) {
    return {
      index: null,
      property: null,
    };
  }
  const res = errorPropertyReg.exec(errorProperty);
  const property = !res[5] && res[2] ? res[2] : res[5];
  return {
    index: res[3],
    property,
  };
};

export const odataErrorHandler = (
  rawError: ODataRawError,
  entity: string,
  field: string | undefined,
  getErrorMessage: (params: GetMessageForErrorCodeArgs) => string,
  useServerErrorMessage: boolean,
): Record<string, IErrorObject[]> => {
  let errors: IODataErrorItem[] = [];
  if (_.isArray(rawError)) {
    errors = rawError;
  } else if (_.isObject(rawError)) {
    if (rawError['@odata.context'] && _.isArray((rawError as any).value)) {
      errors = (rawError as any).value;
    } else if (_.isArray((rawError as any).responseJSON)) {
      errors = (rawError as any).responseJSON;
    } else if (_.isObject((rawError as any).responseJSON) && _.isArray((rawError as any).responseJSON.Errors)) {
      errors = (rawError as any).responseJSON.Errors;
    }
  }
  const entityErrors: Record<string, IErrorObject[]> = {};
  errors.forEach((e) => {
    const { property: errProperty } = getParsedIndexAndProperty(e.Property);
    const errField = field || errProperty || ''; // entity level errors are stored on param ''
    const error: IErrorObject = {
      errorCode: e.Code,
      message: getErrorMessage({
        errorCode: e.Code,
        entity,
        field: field || errProperty,
        serverErrorMessage: useServerErrorMessage && e.Message,
        errMsgObj: e.ErrMsgObj as any,
      }),
      clientId: e.ClientId,
    };
    if (entityErrors[errField]) {
      entityErrors[errField].push(error);
    } else {
      entityErrors[errField] = [error];
    }
  });
  return entityErrors;
};

export function ccErrorHandler(
  rawError: ICCRawError,
  entity: string,
  field: string | undefined,
  getErrorMessage: (params: GetMessageForErrorCodeArgs) => string,
): Record<string, IErrorObject[]> {
  const defaultErrorCode = `ResultType${rawError.ResultType}`;
  if (_.isEmpty(rawError.Errors)) {
    return {
      [field || '']: [{
        errorCode: defaultErrorCode,
        message: getErrorMessage({
          errorCode: defaultErrorCode,
          entity,
          field,
        }),
        clientId: rawError.ClientId,
      }],
    };
  }

  const entityErrors: Record<string, IErrorObject[]> = {};
  rawError.Errors.forEach((e) => {
    const errorCode = e.Code || defaultErrorCode;
    const errField = field || e.FieldId || '';
    const error: IErrorObject = {
      errorCode,
      message: getErrorMessage({ errorCode, entity, field: field || e.FieldId }),
      clientId: e.ClientId,
    };
    if (entityErrors[errField]) {
      entityErrors[errField].push(error);
    } else {
      entityErrors[errField] = [error];
    }
  });

  return entityErrors;
}
